import { Component, input } from '@angular/core';
import { LanguageDto } from '@workspace/data-types';
import { LanguageLabelPipe } from '../../../../../pipes/internationalization/language-iso.pipe';

@Component({
  selector: 'aura-internationalization-language-display',
  templateUrl: './internationalization-language-display.component.html',
  imports: [LanguageLabelPipe],
})
export class AuraInternationalizationLanguageDisplayComponent {
  currentLanguage = input<LanguageDto | null>(null);
}
